import Vue from "vue";

import { store } from '@/store'
import { mapState } from 'vuex';
import router from '@/router'


/**
 * 	LogService
 * 	
 */
export const Navigation = new Vue({

	router,
	store,
	data: {
		nodesByUrl: false,
	},
	computed: {
		...mapState('navigation', ['data', 'current']),
	},

	methods: {

		/**
		 * 	Navigiert zu einem Menüpunkt anhand eines Pfades, z.B.
		 * 	"krankenhaus/station/arztzimmer".
		 * 	Entscheidet, ob die Navigation in die History eingetragen werden soll
		 * 	(push) oder nicht (replace), abhängig davon, ob ich mich in der
		 * 	gleichen Hierarchie befinde. "Zurück" soll immer in den darüberliegenden
		 * 	Raum führen, nicht zu dem zuletzt geklickten auf der gleiche Hierarchie.
		 * 
		 */
		go( data ) {

			if (typeof data == 'string') data = {link:data, node:{url:''}};

			var curNode = this.findNodeByPath( this.$router.currentRoute.params.pathMatch );
			var destNode = this.findNodeByPath( data.link );
		
			if (curNode == destNode) return;

			if (curNode.parent == destNode.parent) {
				this.$router.replace({
					path: `/page/${data.link}`, 
					//query: {link:data.link, nodeUrl:data.node.url}
				}).catch((err)=>{});
			} else {
				this.$router.push({
					path: `/page/${data.link}`, 
					//query: {link:data.link, nodeUrl:data.node.url}
				}).catch((err)=>{});
			}
		},

		/**
		 * 	Einen Schritt zurück navigieren
		 * 
		 */
		back() {
			this.$router.go( -1 );
		},

		/**
		 * 	Findet das Verhältnis zwischen zwei Nodes.
		 * 	'parent'	: 	node1 ist parent von node2
		 * 					('krankenhaus', 'krankenhaus/psychatrie')
		 * 
		 * 	'child'		: 	node1 ist child (oder subchild) von node2
		 * 					('krankenhaus/psychatrie/patientenzimmer1', 'krankenhaus')
		 * 
		 * 	'beside'	: 	node1 ist neben node2 
		 * 					('krankenhaus/station', 'krankenhaus/psychatrie')
		 * 
		 * 	@return object
		 */
		getRelationship( node1, node2 ) {
			if (typeof node1 == 'string') node1 = this.findNodeByPath( node1 );
			if (typeof node2 == 'string') node2 = this.findNodeByPath( node2 );
			if (node1.parent == node2.parent) return 'neighbor';
			var rootLine = this.getRootLine( node2 );
			if (rootLine.indexOf(node1) != -1) return 'parent';
			if (this.isChildOf(node1, node2, true)) return 'child';
			return false;
		},

		/**
		 * 	Prüft, ob node ein Child von parent ist.
		 * 
		 */
		isChildOf( node, parent, recursive ) {
			if (!parent.children) return false;
			if (parent.children.indexOf(node) != -1) return true;
			if (!recursive) return false;
			var isSub = false;
			parent.children.forEach((child) => {
				if (this.isChildOf(node, child)) isSub = true;
			});
			return isSub;
		},

		/**
		 * 	Findet einen Node in navigation.json anhand eines Pfades, z.B.
		 * 	"krankenhaus/station/arztzimmer"
		 * 
		 * 	@return object
		 */
		findNodeByPath( path ) {
			if (typeof path == 'object') return path;

			var ref = this.data;
			if (!path) return ref;

			if (this.nodesByUrl && this.nodesByUrl[path]) {
				return this.nodesByUrl[path];
			}

			path.split('/').forEach((pathPart) => {
				if (pathPart != '' && ref.children) {
					ref.children.forEach((child) => {
						if (child.path == pathPart) ref = child;
					});
				}
			});

			return ref;
		},

		/**
		 * 	Parsed die Daten aus dem JSON, ergänzt Properties.
		 * 
		 * 	@return object
		 */
		parseData( obj, paths ) {

			if (!paths) paths = [];
			if (!obj.hotspots) obj.hotspots = [];
			if (obj.path) paths = paths.concat( obj.path );
			
			obj.url = paths.join('/');
			if (!this.nodesByUrl) this.nodesByUrl = {};
			this.nodesByUrl[obj.url] = obj;

			if (!obj.children) {
				obj.children = [];
				return;
			}
			obj.children.forEach((child) => {
				var myPath = paths.concat( child.path );
				child.parent = obj;
				this.parseData( child, paths );
			});
			return obj;
		},

		/**
		 * 	Holt die Rootline für aktuellen Pfad.
		 * 
		 * 	@return array
		 */
		getRootLine( path ) {
			var node = path ? this.findNodeByPath( path ) : this.current;
			var rootLine = [node];
			while (node.parent) {
				rootLine.push( node.parent );
				node = node.parent;
			}
			return rootLine.reverse();
		},

		/**
		 * 	Einen Wert der navigation.js holen,
		 * 	mit slide.
		 * 
		 * 	@return mixed
		 */
		getField( field = '', path = false, slide = true ) {
			var rootLine = this.getRootLine( path ).reverse();
			if (!slide) {
				var first = rootLine.shift();
				return first[field];
			}
			for (var i in rootLine) {
				if (rootLine[i][field] !== undefined) return rootLine[i][field];
			}
			return;
		}

	}

});